import { useTranslation } from "react-i18next";
import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import {
  getRowWeekStart,
  isInWeek,
} from "../../screens/MainStructure/components/Calendar/calendarFunctions";

export default function MiniCalendar({
  calendarDays,
  calDocsList,
  selected,
  calendarView,
  setSelected,
  selectedWeek,
  selectWeek,
}: {
  calendarDays: stdObject;
  calDocsList: Array<stdObject>;
  selected: string;
  calendarView: string;
  setSelected: (v: string) => void;
  selectedWeek: string;
  selectWeek: (v: string) => void;
}) {
  const { t } = useTranslation();

  const writeEachDay = () => {
    if (!(calendarDays.days > 0)) return null;
    const weeks = Math.ceil((calendarDays.days + calendarDays.dayWeek) / 7);
    let outDay = !!calendarDays.dayWeek;
    let counter = calendarDays.dayWeek
      ? calendarDays.lastDays - calendarDays.dayWeek + 1
      : 1;
    let prefix = calendarDays.dayWeek
      ? calendarDays.previous
      : calendarDays.current;
    return Array.from({ length: weeks }).map((_, index) => {
      const rowWeekStart = getRowWeekStart(
        calendarDays.current,
        calendarDays.dayWeek,
        index,
      );
      const rowSelected = rowWeekStart === selectedWeek;
      return (
        <tr key={index}>
          {Array.from({ length: 7 }).map((_, idx1) => {
            counter =
              (!index && counter > calendarDays.lastDays) ||
              (index && counter > calendarDays.days)
                ? 1
                : counter;
            if (index === 0 && calendarDays.dayWeek && counter === 1) {
              outDay = false;
              prefix = calendarDays.current;
            } else if (index > 0 && counter === 1) {
              outDay = true;
              prefix = calendarDays.next;
            }
            const dayNumber = counter;
            const isOutDay = outDay;
            const cellId = `${prefix}-${
              dayNumber < 10 ? "0" + dayNumber : dayNumber
            }`;
            counter++;

            const count = calDocsList.filter(
              (e: stdObject) =>
                typeof e.data.FEC2SEV === "string" &&
                e.data.FEC2SEV.includes(cellId),
            ).length;
            const highlighted =
              rowSelected || cellId === selected || isInWeek(cellId, selectedWeek);

            return (
              <td
                key={idx1}
                className="miniCalendarTd noSelect"
                style={{
                  backgroundColor: highlighted
                    ? colors.lightBlue2
                    : isOutDay
                      ? colors.lightGrey
                      : colors.white,
                  cursor: "pointer",
                }}
                onClick={() =>
                  calendarView === "week"
                    ? selectWeek(rowWeekStart)
                    : setSelected(cellId)
                }
              >
                <div
                  style={{
                    position: "absolute",
                    top: 2,
                    left: 2,
                    color: isOutDay ? colors.darkGrey : undefined,
                  }}
                >
                  {dayNumber}
                </div>
                {count > 0 && <div className="miniCalendarCount">{count}</div>}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  return (
    <div className="miniCalendarBox" style={{ flex: 1 }}>
      <table className="miniCalendarTable" cellSpacing={0} cellPadding={0}>
        <thead>
          <tr>
            {Array.from({ length: 7 }).map((_, index) => (
              <th key={index}>{t(`p.d${index}m`)}</th>
            ))}
          </tr>
        </thead>
        <tbody>{writeEachDay()}</tbody>
      </table>
    </div>
  );
}
